export const gallerySections = [
  {
    title: "28th Anniversary Celebrations",
    subtitle: "(25-07-2026)",
    year: 2026,
    images: [
      "/img/Gallery/28th Anniversary Celebrations/1.jpg",
      "/img/Gallery/28th Anniversary Celebrations/2.jpg",
      "/img/Gallery/28th Anniversary Celebrations/3.jpg",
      "/img/Gallery/28th Anniversary Celebrations/4.jpg",
      "/img/Gallery/28th Anniversary Celebrations/5.jpg",
      "/img/Gallery/28th Anniversary Celebrations/6.jpg",
    ],
  },
  {
    title: "Glimpses from the INTRON Half-Yearly Review Meeting 2026",
    subtitle: "(27-29th November' 2026)",
    year: 2026,
    images: [
      "/img/Gallery/Glimpses from the INTRON Half-Yearly Review Meeting/1.jpg",
      "/img/Gallery/Glimpses from the INTRON Half-Yearly Review Meeting/2.jpg",
      "/img/Gallery/Glimpses from the INTRON Half-Yearly Review Meeting/3.jpg",
    ],
  },
  {
    title: "AQUAEX LUCKNOW 2026",
    subtitle: "(27-29th November' 2026)",
    year: 2026,
    images: [
      "/img/Gallery/AQUAEX LUCKNOW 2026/1.jpeg",
      "/img/Gallery/AQUAEX LUCKNOW 2026/2.jpeg",
      "/img/Gallery/AQUAEX LUCKNOW 2026/3.jpeg",
    ],
  },
  {
    title: "12th Kolkata International Poultry Fair 2026",
    subtitle: "(11-10-2025 to 13-10-2025)",
    year: 2026,
    images: [
      "/img/Gallery/12th Kolkata International Poultry Fair 2026/1.jpg",
      "/img/Gallery/12th Kolkata International Poultry Fair 2026/2.jpg",
      "/img/Gallery/12th Kolkata International Poultry Fair 2026/3.jpg",
    ],
  },
  {
    title: "Poutry India, 2025",
    subtitle: "(11-10-2025 to 13-10-2025)",
    year: 2025,
    images: [
      "/img/Gallery/Poultry India 2025/1.jpeg",
      "/img/Gallery/Poultry India 2025/2.jpg",
      "/img/Gallery/Poultry India 2025/3.jpeg",
      "/img/Gallery/Poultry India 2025/4.jpg",
      "/img/Gallery/Poultry India 2025/5.jpg",
      "/img/Gallery/Poultry India 2025/8.JPG",
    ],
  },
  {
    title: "AQUAEX INDIA 2025, Bhimavaram, A.P, INDIA",
    subtitle: "(11-10-2025 to 13-10-2025)",
    year: 2025,
    images: [
      "/img/Gallery/AQUAEX INDIA 2025, Bhimavaram, A.P, INDIA 11-10-2025 to 13-10-2025/1.jpg",
      "/img/Gallery/AQUAEX INDIA 2025, Bhimavaram, A.P, INDIA 11-10-2025 to 13-10-2025/2.jpg",
      "/img/Gallery/AQUAEX INDIA 2025, Bhimavaram, A.P, INDIA 11-10-2025 to 13-10-2025/3.jpg",
      "/img/Gallery/AQUAEX INDIA 2025, Bhimavaram, A.P, INDIA 11-10-2025 to 13-10-2025/4.jpg",
      "/img/Gallery/AQUAEX INDIA 2025, Bhimavaram, A.P, INDIA 11-10-2025 to 13-10-2025/5.jpeg",
      "/img/Gallery/AQUAEX INDIA 2025, Bhimavaram, A.P, INDIA 11-10-2025 to 13-10-2025/6.jpeg"
    ],
  },
  {
    title: "36th Annual General Meeting of the Poultry Federation of India",
    subtitle: "(8/10/2025 & 9/10/2025)",
    year: 2025,
    images: [
      "/img/Gallery/36th Annual General Meeting of the Poultry Federation of India/1.jpg",
      "/img/Gallery/36th Annual General Meeting of the Poultry Federation of India/2.jpg",
      "/img/Gallery/36th Annual General Meeting of the Poultry Federation of India/3.jpg",
    ],
  },
  {
    title: "Aquaculture Farmers Meeting with 110 Farmers, Manchili, West Godavari, A.P",
    subtitle: "(22-08-2025)",
    year: 2025,
    images: [
      "/img/Gallery/Aquaculture Farmers Meeting with 110 Farmers, Manchili, West Godavari, A.P 22-08-2025/1.jpg",
      "/img/Gallery/Aquaculture Farmers Meeting with 110 Farmers, Manchili, West Godavari, A.P 22-08-2025/2.jpg",
      "/img/Gallery/Aquaculture Farmers Meeting with 110 Farmers, Manchili, West Godavari, A.P 22-08-2025/3.jpg",
    ],
  },
  {
    title: "Broiler Quality Conference 2025, The Landmark Bangkok, Thailand",
    subtitle: "(05-08-2025)",
    year: 2025,
    images: [
      "/img/Gallery/Broiler Quality Conference 2025, The Landmark Bangkok, Thailand 05-08-2025/1.jpg",
      "/img/Gallery/Broiler Quality Conference 2025, The Landmark Bangkok, Thailand 05-08-2025/2.jpeg",
      "/img/Gallery/Broiler Quality Conference 2025, The Landmark Bangkok, Thailand 05-08-2025/3.jpg"
    ],
  },
  {
    title: "Technical Product Presentation, Bangkok",
    subtitle: "(04-08-2025)",
    year: 2025,
    images: [
      "/img/Gallery/Technical Product Presentation, Bangkok 04-08-2025/1.jpg",
      "/img/Gallery/Technical Product Presentation, Bangkok 04-08-2025/2.jpg",
      "/img/Gallery/Technical Product Presentation, Bangkok 04-08-2025/3.jpg",
    ],
  },
  {
    title: "27th Anniversary Celebrations",
    subtitle: "(25-07-2025)",
    year: 2025,
    images: [
      "/img/Gallery/27th Anniversary Celebrations 25-07-2025/1.jpg",
      "/img/Gallery/27th Anniversary Celebrations 25-07-2025/2.jpg",
      "/img/Gallery/27th Anniversary Celebrations 25-07-2025/3.jpg",
      "/img/Gallery/27th Anniversary Celebrations 25-07-2025/4.jpg",
      "/img/Gallery/27th Anniversary Celebrations 25-07-2025/5.jpg",
    ],
  },
  {
    title: "Glimpses from the INTRON Half-Yearly Review Meeting - Aquaculture Division at Hyderabad",
    subtitle: "(09-07-2025)",
    year: 2025,
    images: [
      "/img/Gallery/Glimpses from the INTRON Half-Yearly Review Meeting - Aquaculture Division at Hyderabad 09-07-2025/1.jpg",
      "/img/Gallery/Glimpses from the INTRON Half-Yearly Review Meeting - Aquaculture Division at Hyderabad 09-07-2025/2.jpg",
      "/img/Gallery/Glimpses from the INTRON Half-Yearly Review Meeting - Aquaculture Division at Hyderabad 09-07-2025/3.jpg",
    ],
  },
  {
    title: "On - Site Medical Camp at Intron",
    subtitle: "(12-06-2025)",
    year: 2025,
    images: [
      "/img/Gallery/On - Site Medical Camp at Intron 12-06-2025/1.jpg",
      "/img/Gallery/On - Site Medical Camp at Intron 12-06-2025/2.jpg",
      "/img/Gallery/On - Site Medical Camp at Intron 12-06-2025/3.jpg",
    ],
  },
  {
    title: "ISABELA Poultry Forum, Cauayan City, Philippines",
    subtitle: "(27-09-2025)",
    year: 2025,
    images: [
      "/img/Gallery/ISABELA Poultry Forum, Cauayan City, Philippines, 27-09-2025/1.jpg",
      "/img/Gallery/ISABELA Poultry Forum, Cauayan City, Philippines, 27-09-2025/2.jpg",
      "/img/Gallery/ISABELA Poultry Forum, Cauayan City, Philippines, 27-09-2025/3.jpg",
    ],
  },
  {
    title: "Cardiac Rehab Run",
    subtitle: "(21-09-2025)",
    year: 2025,
    images: [
      "/img/Gallery/Cardiac Rehab Run 21-09-2025/1.jpg",
    ],
  },
  {
    title: "Kolkata International Poultry Fair 2025, Kolkata, West Bengal",
    subtitle: "(13-02-2025)",
    year: 2025,
    images: [
      "/img/Gallery/Kolkata International Poultry Fair 2025, Kolkata, West Bengal 13-02-2025/1.jpg",
      "/img/Gallery/Kolkata International Poultry Fair 2025, Kolkata, West Bengal 13-02-2025/2.jpg",
      "/img/Gallery/Kolkata International Poultry Fair 2025, Kolkata, West Bengal 13-02-2025/3.jpg",
    ],
  },
  {
    title: "Training session for the Premium Chicks & Feeds Pvt Ltd team in Pune",
    subtitle: "(18.02.2025)",
    year: 2025,
    images: [
      "/img/Gallery/Training session for the Premium Chicks & Feeds Pvt Ltd team in Pune on 18.02.2025/1.jpg",
      "/img/Gallery/Training session for the Premium Chicks & Feeds Pvt Ltd team in Pune on 18.02.2025/2.jpg",
      "/img/Gallery/Training session for the Premium Chicks & Feeds Pvt Ltd team in Pune on 18.02.2025/3.jpg",
    ],
  },
  {
    title: "Intron has organized Farmers meeting at KP Palem, West Godavari District, A.P",
    subtitle: "(10th March' 2025) - Approximately 107 farmers attended",
    year: 2025,
    images: [
      "/img/Gallery/Intron has organized Farmers meeting on 10th March’ 2025 at KP Palem, West Godavari District, A.P. Approximately 107 farmers attended the meeting/1.jpg",
      "/img/Gallery/Intron has organized Farmers meeting on 10th March’ 2025 at KP Palem, West Godavari District, A.P. Approximately 107 farmers attended the meeting/2.jpg",
      "/img/Gallery/Intron has organized Farmers meeting on 10th March’ 2025 at KP Palem, West Godavari District, A.P. Approximately 107 farmers attended the meeting/3.jpg",
    ],
  },
  {
    title: "Intron has organized Farmers meeting at Krishnapatnam, SPSR Nellore District, A.P",
    subtitle: "(24th March' 2025) - Approximately 50 farmers attended",
    year: 2025,
    images: [
      "/img/Gallery/Intron has organized Farmers meeting on 24th March’ 2025 at Krishnapatnam, SPSR Nellore District, A.P. Approximately 50 farmers attended the meeting/1.jpg",
      "/img/Gallery/Intron has organized Farmers meeting on 24th March’ 2025 at Krishnapatnam, SPSR Nellore District, A.P. Approximately 50 farmers attended the meeting/2.jpg",
      "/img/Gallery/Intron has organized Farmers meeting on 24th March’ 2025 at Krishnapatnam, SPSR Nellore District, A.P. Approximately 50 farmers attended the meeting/3.jpg",
    ],
  },
  {
    title: "Gujarat Aqua Dealers Meeting, Daman",
    subtitle: "(11-11-2025)",
    year: 2025,
    images: [
      "/img/Gallery/Gujarat Aqua Dealers Meeting, Daman 11-11-2025/4.JPG",
      "/img/Gallery/Gujarat Aqua Dealers Meeting, Daman 11-11-2025/5.JPG",
      "/img/Gallery/Gujarat Aqua Dealers Meeting, Daman 11-11-2025/6.jpeg",
    ],
  },
  {
    title: "World Aquaculture Society, HICC Hyderabad",
    subtitle: "(12-11-2025)",
    year: 2025,
    images: [
      "/img/Gallery/World Aquaculture Society, HICC Hyderabad, 12-11-2025/1.jpg",
      "/img/Gallery/World Aquaculture Society, HICC Hyderabad, 12-11-2025/2.jpg",
      "/img/Gallery/World Aquaculture Society, HICC Hyderabad, 12-11-2025/3.png",
    ],
  },
  {
    title: "26th Anniversary Celebrations",
    subtitle: "(25-07-2024)",
    year: 2024,
    images: [
      "/img/Gallery/26th Anniversary Celebrations 25-07-2024/1.jpg",
      "/img/Gallery/26th Anniversary Celebrations 25-07-2024/2.jpg",
      "/img/Gallery/26th Anniversary Celebrations 25-07-2024/3.jpg",
      "/img/Gallery/26th Anniversary Celebrations 25-07-2024/4.jpg",
      "/img/Gallery/26th Anniversary Celebrations 25-07-2024/5.jpg",
    ],
  },
  {
    title: "Farmers Meeting at Banshichak, Belda, Dist- Paschim Medinipur, West Bengal",
    subtitle: "(26-07-2024)",
    year: 2024,
    images: [
      "/img/Gallery/Farmers_ Meeting at Banshichak, Belda, Dist- Paschim Medinipur, West Bengal 26-07-2024/1.jpg",
      "/img/Gallery/Farmers_ Meeting at Banshichak, Belda, Dist- Paschim Medinipur, West Bengal 26-07-2024/2.jpg",
      "/img/Gallery/Farmers_ Meeting at Banshichak, Belda, Dist- Paschim Medinipur, West Bengal 26-07-2024/3.jpg",
    ],
  },
  {
    title: "POULTRY INDIA 2024, Hitex Exhibition Centre, Hyderabad",
    subtitle: "(27-11-2024 to 29-11-2024)",
    year: 2024,
    images: [
      "/img/Gallery/POULTRY INDIA 2024, Hitex Exhibition Centre, Hyderabad 27-11-2024 to 29-11-2024/1.jpg",
      "/img/Gallery/POULTRY INDIA 2024, Hitex Exhibition Centre, Hyderabad 27-11-2024 to 29-11-2024/2.jpg",
      "/img/Gallery/POULTRY INDIA 2024, Hitex Exhibition Centre, Hyderabad 27-11-2024 to 29-11-2024/3.jpg",
    ],
  },
  {
    title: "Aquaculture Expo 2024 Hisar, Haryana",
    subtitle: "(22-01-2024)",
    year: 2024,
    images: [
      "/img/Gallery/Aquaculture Expo 2024 Hisar, Haryana 22-01-2024/1.jpg",
      "/img/Gallery/Aquaculture Expo 2024 Hisar, Haryana 22-01-2024/2.jpg",
      "/img/Gallery/Aquaculture Expo 2024 Hisar, Haryana 22-01-2024/3.jpg",
    ],
  },
  {
    title: "Matsya Sampada Jagrukta Abhiyan - One Day Workshop at Narasapuram, West Godavari District, A.P",
    subtitle: "(13-02-2024)",
    year: 2024,
    images: [
      "/img/Gallery/Matsya Sampada Jagrukta Abhiyan - One Day Workshop at Narasapuram, West Godavari District, A.P 13-02-2024/1.jpg",
      "/img/Gallery/Matsya Sampada Jagrukta Abhiyan - One Day Workshop at Narasapuram, West Godavari District, A.P 13-02-2024/2.jpg",
      "/img/Gallery/Matsya Sampada Jagrukta Abhiyan - One Day Workshop at Narasapuram, West Godavari District, A.P 13-02-2024/3.jpg",
    ],
  },
  {
    title: "Kolkata International Poultry Fair - 2024, Kolkata, West Bengal",
    subtitle: "(08-02-2024)",
    year: 2024,
    images: [
      "/img/Gallery/Kolkata International Poultry Fair - 2024, Kolkata, West Bengal 08-02-2024/1.jpg",
      "/img/Gallery/Kolkata International Poultry Fair - 2024, Kolkata, West Bengal 08-02-2024/2.jpg",
      "/img/Gallery/Kolkata International Poultry Fair - 2024, Kolkata, West Bengal 08-02-2024/3.jpg",
    ],
  },
  {
    title: "Moyna Aqua Expo 2024, Moyna, Purba Medinipur, West Bengal",
    subtitle: "(06-01 to 07-01-2024)",
    year: 2024,
    images: [
      "/img/Gallery/Moyna Aqua Expo 2024, Moyna, Purba Medinipur, West Bengal 06-01 to 07-01-2024/1.jpg",
      "/img/Gallery/Moyna Aqua Expo 2024, Moyna, Purba Medinipur, West Bengal 06-01 to 07-01-2024/2.jpg",
      "/img/Gallery/Moyna Aqua Expo 2024, Moyna, Purba Medinipur, West Bengal 06-01 to 07-01-2024/3.jpg",
    ],
  },
  {
    title: "25th Anniversary Celebrations",
    subtitle: "(25-07-2023)",
    year: 2023,
    images: [
      "/img/Gallery/25th Anniversary Celebrations 25-07-2023/1.jpg",
      "/img/Gallery/25th Anniversary Celebrations 25-07-2023/2.jpg",
      "/img/Gallery/25th Anniversary Celebrations 25-07-2023/3.jpg",
    ],
  },
  {
    title: "VIV ASIA 2023, Bangkok",
    subtitle: "(08-03-2023 to 10-03-2024)",
    year: 2023,
    images: [
      "/img/Gallery/VIV ASIA 2023, Bangkok 08-03-2023 to 10-03-2024/1.jpg",
      "/img/Gallery/VIV ASIA 2023, Bangkok 08-03-2023 to 10-03-2024/2.jpg",
    ],
  },
  {
    title: "Kolkata International Poultry Fair 2023",
    subtitle: "(10-2-2023)",
    year: 2023,
    images: [
      "/img/Gallery/Kolkata International Poultry Fair 2023 10-2-2023/1.jpg",
      "/img/Gallery/Kolkata International Poultry Fair 2023 10-2-2023/2.jpg",
      "/img/Gallery/Kolkata International Poultry Fair 2023 10-2-2023/3.jpg",
    ],
  },
  {
    title: "Mahapashudhan Expo 2023, Nashik",
    subtitle: "(25-03-2023)",
    year: 2023,
    images: [
      "/img/Gallery/Mahapashudhan Expo 2023, Nashik 25-03-2023/1.jpg",
      "/img/Gallery/Mahapashudhan Expo 2023, Nashik 25-03-2023/2.jpg",
    ],
  },
  {
    title: "Poultry India 2023, Hitex Exhibition Centre, Hyderabad, India",
    subtitle: "(23-11-2023)",
    year: 2023,
    images: [
      "/img/Gallery/Poultry India 2023, Hitex Exhibition Centre, Hyderabad, India 23-11-2023/1.jpg",
      "/img/Gallery/Poultry India 2023, Hitex Exhibition Centre, Hyderabad, India 23-11-2023/2.jpg",
      "/img/Gallery/Poultry India 2023, Hitex Exhibition Centre, Hyderabad, India 23-11-2023/3.jpg",
    ],
  },
  {
    title: "VIETSHRIMP 2023, Vietnam",
    year: 2023,
    images: [
      "/img/Gallery/VIETSHRIMP 2023, Vietnam/1.jpg",
      "/img/Gallery/VIETSHRIMP 2023, Vietnam/2.jpg",
      "/img/Gallery/VIETSHRIMP 2023, Vietnam/3.jpg",
    ],
  },
  {
    title: "Intron Life Sciences Vietnam team delivered a lecture at Bac Lieu University, Bac Lieu City, Vietnam",
    subtitle: "(13th Sept 2023)",
    year: 2023,
    images: [
      "/img/Gallery/Intron Life Sciences Vietnam team delivered a lecture at Bac Lieu University, Bac Lieu City, Vietnam 13th Sept 2023/1.jpg",
      "/img/Gallery/Intron Life Sciences Vietnam team delivered a lecture at Bac Lieu University, Bac Lieu City, Vietnam 13th Sept 2023/2.jpg",
      "/img/Gallery/Intron Life Sciences Vietnam team delivered a lecture at Bac Lieu University, Bac Lieu City, Vietnam 13th Sept 2023/3.jpg",
    ],
  },
  {
    title: "24th Anniversary Celebrations",
    subtitle: "(25-07-2022)",
    year: 2022,
    images: [
      "/img/Gallery/24th Anniversary Celebrations 25-07-2022/1.jpg",
      "/img/Gallery/24th Anniversary Celebrations 25-07-2022/2.jpg",
      "/img/Gallery/24th Anniversary Celebrations 25-07-2022/3.jpg",
    ],
  },
  {
    title: "Seminar at Nachinda, Contai, West Bengal",
    subtitle: "(01-03-2022)",
    year: 2022,
    images: [
      "/img/Gallery/Seminar at Nachinda, Contai, West Bengal 01-03-2022/1.jpg",
      "/img/Gallery/Seminar at Nachinda, Contai, West Bengal 01-03-2022/2.jpg",
    ],
  },
  {
    title: "Aqua Expo 2022 Hisar, Haryana",
    subtitle: "(20-11-2022)",
    year: 2022,
    images: [
      "/img/Gallery/Aqua Expo 2022 Hisar, Haryana 20-11-2022/1.jpg",
      "/img/Gallery/Aqua Expo 2022 Hisar, Haryana 20-11-2022/2.jpg",
      "/img/Gallery/Aqua Expo 2022 Hisar, Haryana 20-11-2022/3.jpg",
    ],
  },
  {
    title: "Poultry India 2022, Hitex Exhibition Centre, Hyderabad, India",
    subtitle: "(23-11-2022)",
    year: 2022,
    images: [
      "/img/Gallery/Poultry India 2022, Hitex Exhibition Centre, Hyderabad, India 23-11-2022/1.jpg",
      "/img/Gallery/Poultry India 2022, Hitex Exhibition Centre, Hyderabad, India 23-11-2022/2.jpg",
      "/img/Gallery/Poultry India 2022, Hitex Exhibition Centre, Hyderabad, India 23-11-2022/3.jpg",
    ],
  },
  {
    title: "Intron Life Sciences is the major sponsor for the Jalalpore Premier League (JPL) - Season 4 cricket tournament at Jalalpore, Navsari district, Gujarat",
    subtitle: "(28-12-2022)",
    year: 2022,
    images: [
      "/img/Gallery/Intron Life Sciences is the major sponsor for the Jalalpore Premier League (JPL) - Season 4 cricket tournament at Jalalpore, Navsari district, Gujarat 28-12-2022/1.jpg",
      "/img/Gallery/Intron Life Sciences is the major sponsor for the Jalalpore Premier League (JPL) - Season 4 cricket tournament at Jalalpore, Navsari district, Gujarat 28-12-2022/2.jpg",
      "/img/Gallery/Intron Life Sciences is the major sponsor for the Jalalpore Premier League (JPL) - Season 4 cricket tournament at Jalalpore, Navsari district, Gujarat 28-12-2022/3.jpg",
    ],
  },
  {
    title: "23rd Anniversary Celebrations",
    subtitle: "(25-07-2021)",
    year: 2021,
    images: [
      "/img/Gallery/23rd Anniversary Celebrations 25-07-2021/1.jpg",
      "/img/Gallery/23rd Anniversary Celebrations 25-07-2021/2.jpg",
      "/img/Gallery/23rd Anniversary Celebrations 25-07-2021/3.jpg",
    ],
  },
];